import { Box, Heading, Image, Text } from '@resideo/blueprint-react';
import { backArrow } from 'assets/images';
import Page from 'components/common/Page';
import MonitorItems from 'components/MonitorItems';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

const SeparatorLine = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.background};
  background-color: ${({ theme }) => theme.colors.background};
  height: 0px;
`;

const RefreshMonitor: FunctionComponent<any> = ({ history }) => {
  const { t } = useTranslation();

  const data = [
    {
      title: 'AirCycle Device Refresh',
      deviceId: 34150,
      deviceNumber: 'HH05',
      expiryDate: 'August 5, 2021',
      price: 795,
      status: 'added',
      type: 'refresh',
    },
    {
      title: 'AirCycle Device Refresh',
      deviceId: 34150,
      deviceNumber: 'HH05',
      expiryDate: 'August 5, 2020',
      price: 795,
      status: '',
      type: 'refresh',
    },
    {
      title: 'AirCycle Device Refresh',
      deviceId: 34150,
      deviceNumber: 'HH05',
      expiryDate: 'August 5, 2021',
      price: 795,
      status: '',
      type: 'refresh',
    },
    {
      title: 'AirCycle Device Refresh',
      deviceId: 34150,
      deviceNumber: 'HH05',
      expiryDate: 'August 5, 2021',
      price: 795,
      status: 'added',
      type: 'refresh',
    },
    {
      title: 'AirCycle Device Refresh',
      deviceId: 34150,
      deviceNumber: 'HH05',
      expiryDate: 'August 5, 2020',
      price: 795,
      status: '',
      type: 'refresh',
    },
    {
      title: 'AirCycle Device Refresh',
      deviceId: 34150,
      deviceNumber: 'HH05',
      expiryDate: 'August 5, 2021',
      price: 795,
      status: '',
      type: 'refresh',
    },
  ];

  return (
    <Page
      as='main'
      minWidth='100%'
      paddingX={['medium', 'medium', 'large', 'xLarge']}
      paddingY='small'
      data-test-refresh-monitor>
      <Heading
        fontFamily='URW_Din_CondBold'
        textAlign='center'
        className='text-uppercase'
        color='titleLarge'
        paddingTop={['medium', 'medium', 'large', 'large']}
        fontSize={['2.3rem', '2.5rem', '2.812rem', '2.8125rem']}>
        {t('refreshMonitor.currentlyInYourCart')}
      </Heading>
      <Box
        display='flex'
        alignItems='center'
        className='cursor-pointer back-arrow-animation'
        onClick={() => history.goBack()}>
        <Image src={backArrow} alt='backArrow' />
        <Text
          marginLeft='small'
          fontSize='small'
          fontWeight='bold'
          color='primary'
          className='text-uppercase'>
          {t('back')}
        </Text>
      </Box>
      <Box
        paddingTop='large'
        className='app-container'
        display='flex'
        justifyContent='center'
        maxWidth='40rem !important'
        marginBottom='large'>
        <MonitorItems
          data={{
            title: 'AirCycle Pro Monitor',
            deviceId: 34150,
            deviceNumber: 'IAQMNXXSA1000TRAIN',
            expiryDate: 'August 5, 2020',
            status: 'continued',
          }}
        />
      </Box>
      <SeparatorLine marginBottom='large' />
      <Heading
        fontFamily='URW_Din_CondBold'
        textAlign='center'
        className='text-uppercase'
        color='titleLarge'
        paddingTop={['medium', 'medium', 'large', 'large']}
        fontSize={['2.4rem', '2.8rem', '2.9rem', '3rem']}>
        {t('refreshMonitor.wouldYouLikeToAddAdditionalDevice')}
      </Heading>
      <Heading
        fontSize={['small', 'small', 'medium', 'medium']}
        fontWeight='bold'
        color='black'
        textAlign='center'
        paddingTop='small'
        marginBottom='xLarge'>
        {t('refreshMonitor.theseDevicesAreExpiredOrExpiringSoon')}
      </Heading>
      <Box
        paddingTop='large'
        className='app-container custom-scroll-bar'
        marginBottom='large'
        maxHeight='32rem'
        overflowY='auto'>
        {data.map((res, ind) => (
          <Box key={ind}>
            <MonitorItems data={res} />
            <Box paddingY='large'>
              <SeparatorLine />
            </Box>
          </Box>
        ))}
      </Box>
    </Page>
  );
};

export default withRouter(RefreshMonitor);
